import React from "react";
import { useLocation } from "react-router-dom";
import { metaDefault } from "../../config/meta";
import { getString } from "../../utilities";
import aboutStrings from "../../strings/about";

export default function PrivacyMobile() {
  const { pathname } = useLocation();

  return (
    <>
      {metaDefault({ path: pathname, title: getString("privacymobile.title.0") })}

      <div className="privacymobile">
        <div className="wrapper padded">
          <div className="container">
            <h1>{getString("privacymobile.title.0")}</h1>
          </div>
        </div>

        <div className="wrapper padded">
          <div className="container-medium">
            {getString("privacymobile.body", { html: true, strings: aboutStrings })}
          </div>
        </div>
      </div>

      <div className="wrapper header-shadow" />
    </>
  );
}
